var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar',{ref:"toolbar",staticStyle:{"border-bottom":"1px solid #ccc"},attrs:{"editor":_vm.editor,"defaultConfig":_vm.toolbarConfig}}),_c('Editor',{staticClass:"editor",attrs:{"defaultConfig":_vm.editorConfig},on:{"onCreated":_vm.editorCreated},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }